export const DS_COLOR_WHITE = '#ffffff';
export const DS_COLOR_BLACK = '#000000';

// Primary
export const DS_COLOR_PRIMARY_25 = '#EDF5FD';
export const DS_COLOR_PRIMARY_50 = '#E5F4FF';
export const DS_COLOR_PRIMARY_100 = '#CCE9FF';
export const DS_COLOR_PRIMARY_200 = '#A7D9F8';
export const DS_COLOR_PRIMARY_300 = '#6FB2DD';
export const DS_COLOR_PRIMARY_400 = '#3091CE';
export const DS_COLOR_PRIMARY_500 = '#067EBA';
export const DS_COLOR_PRIMARY_600 = '#006497';
export const DS_COLOR_PRIMARY_700 = '#004B73';
export const DS_COLOR_PRIMARY_800 = '#003350';
export const DS_COLOR_PRIMARY_900 = '#001E31';

// Gray
export const DS_COLOR_GRAY_25 = '#F8FAFB';
export const DS_COLOR_GRAY_50 = '#F5F7FA';
export const DS_COLOR_GRAY_100 = '#EFF4F8';
export const DS_COLOR_GRAY_200 = '#E1E9F0';
export const DS_COLOR_GRAY_300 = '#D7E0E9';
export const DS_COLOR_GRAY_400 = '#CBD5E0';
export const DS_COLOR_GRAY_500 = '#A0AEC0';
export const DS_COLOR_GRAY_600 = '#718096';
export const DS_COLOR_GRAY_700 = '#4A5568';
export const DS_COLOR_GRAY_800 = '#2D3748';
export const DS_COLOR_GRAY_900 = '#1E2634';

// Success
export const DS_COLOR_SUCCESS_25 = '#F6FEF9';
export const DS_COLOR_SUCCESS_50 = '#ECFDF3';
export const DS_COLOR_SUCCESS_100 = '#D1FADF';
export const DS_COLOR_SUCCESS_200 = '#A6F4C5';
export const DS_COLOR_SUCCESS_300 = '#6CE9A6';
export const DS_COLOR_SUCCESS_400 = '#32D583';
export const DS_COLOR_SUCCESS_500 = '#12B76A';
export const DS_COLOR_SUCCESS_600 = '#039855';
export const DS_COLOR_SUCCESS_700 = '#027A48';
export const DS_COLOR_SUCCESS_800 = '#05603A';
export const DS_COLOR_SUCCESS_900 = '#054F31';

// Warning
export const DS_COLOR_WARNING_25 = '#FFFCF5';
export const DS_COLOR_WARNING_50 = '#FFFAEB';
export const DS_COLOR_WARNING_100 = '#FEF0C7';
export const DS_COLOR_WARNING_200 = '#FEDF89';
export const DS_COLOR_WARNING_300 = '#FEC84B';
export const DS_COLOR_WARNING_400 = '#FDB022';
export const DS_COLOR_WARNING_500 = '#F79009';
export const DS_COLOR_WARNING_600 = '#DC6803';
export const DS_COLOR_WARNING_700 = '#B54708';
export const DS_COLOR_WARNING_800 = '#93370D';
export const DS_COLOR_WARNING_900 = '#792E0D';

// Danger
export const DS_COLOR_DANGER_25 = '#FFFAFA';
export const DS_COLOR_DANGER_50 = '#FEF3F2';
export const DS_COLOR_DANGER_100 = '#FEE4E2';
export const DS_COLOR_DANGER_200 = '#FECDC9';
export const DS_COLOR_DANGER_300 = '#FDA19B';
export const DS_COLOR_DANGER_400 = '#F97066';
export const DS_COLOR_DANGER_500 = '#F04438';
export const DS_COLOR_DANGER_600 = '#D92D20';
export const DS_COLOR_DANGER_700 = '#B32318';
export const DS_COLOR_DANGER_800 = '#912018';
export const DS_COLOR_DANGER_900 = '#7A271A';

// Special Content
export const DS_COLOR_SPECIAL_CONTENT_BLACKISH = '#333333';
export const DS_COLOR_SPECIAL_CONTENT_NATURAL_GRAY = '#808080';
export const DS_COLOR_SPECIAL_CONTENT_LIGHT_GRAY = '#C4C4C4';
export const DS_COLOR_SPECIAL_CONTENT_WINTER = '#A9ADBD';
export const DS_COLOR_SPECIAL_CONTENT_RIVER = '#6BA1BD';
export const DS_COLOR_SPECIAL_CONTENT_DARK_BLUE = '#008CC0';
export const DS_COLOR_SPECIAL_CONTENT_NAVY = '#215091';
export const DS_COLOR_SPECIAL_CONTENT_DARK_INDIGO = '#44197C';
export const DS_COLOR_SPECIAL_CONTENT_DARK_PURPLE = '#748BD1';
export const DS_COLOR_SPECIAL_CONTENT_BUBBLE = '#FAF1FF';
export const DS_COLOR_SPECIAL_CONTENT_LIPSTICK = '#FF5AC4';
export const DS_COLOR_SPECIAL_CONTENT_SOFIA_PINK = '#FF158A';
export const DS_COLOR_SPECIAL_CONTENT_BERRY = '#7E38BA';
export const DS_COLOR_SPECIAL_CONTENT_RED = '#E2445C';
export const DS_COLOR_SPECIAL_CONTENT_DARK_RED = '#B83354';
export const DS_COLOR_SPECIAL_CONTENT_SUNSET = '#FF7575';
export const DS_COLOR_SPECIAL_CONTENT_PEACH = '#FFADAD';
export const DS_COLOR_SPECIAL_CONTENT_BROWN = '#7F5347';
export const DS_COLOR_SPECIAL_CONTENT_EGG_YOLK = '#FFC800';
export const DS_COLOR_SPECIAL_CONTENT_ORANGE = '#FDA83D';
export const DS_COLOR_SPECIAL_CONTENT_SAND = '#C8A841';
export const DS_COLOR_SPECIAL_CONTENT_BRIGHT_GREEN = '#9CD326';
export const DS_COLOR_SPECIAL_CONTENT_GREEN = '#00CB75';
export const DS_COLOR_SPECIAL_CONTENT_GRASS_GREEN = '#3F874C';
export const DS_COLOR_SPECIAL_CONTENT_AQUAMARINE = '#037F4C';
export const DS_COLOR_SPECIAL_CONTENT_CHILLBLUE = '#01C8B5';
export const DS_COLOR_SPECIAL_CONTENT_LIGHTBLUE = '#0FAFAF';
export const DS_COLOR_SPECIAL_CONTENT_INDIGO = '#5559DF';
export const DS_COLOR_SPECIAL_CONTENT_PURPLE = '#A661E0';
export const DS_COLOR_SPECIAL_CONTENT_DARK_ORANGE = '#FF6F42';
